<template>
    <div>
        <el-tree
            ref="tree"
            :data="treeData"
            :default-checked-keys="checkedEventCategories"
            empty-text="Test"
            :props="treeProps"
            accordion
            node-key="id"
            @check="handleCategoryChecked">
            <template #default="{ node }">
                <div
                    class="d-flex w-100 justify-content-between align-items-center overflow-hidden">
                    <span
                        class="el-tree-node__label"
                        @click.stop>
                        <CategoryCheckbox
                            v-if="!node.data.disabled"
                            :node="node"
                            :checked-categories="checkedCategories"
                            @check="checkCategory" />
                        <span v-else>{{ node.label }}</span>
                    </span>
                </div>
            </template>
        </el-tree>
    </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import CategoryCheckbox from "./CategoryCheckbox";

export default {
    name: "EventCategoriesTree",
    components: {
        CategoryCheckbox,
    },
    props: {
        checkedEventCategories: {type: Array},
        treeData: {type: Array}
    },
    data() {
        return {
            editNode: false,
            checkedCategories: []
        }
    },
    computed: {
        treeProps() {
            return {
                children: 'childVeranstaltungskategorien',
                label: 'Bezeichnung'
            }
        }
    },
    methods: {
        handleCategoryChecked() {
            this.$emit('update:checkedEventCategories', cloneDeep(this.checkedCategories))
        },
        checkCategory(event) {
            this.checkedCategories = this.checkedCategories.filter(category => category !== event.id)
            if(event.value) {
                this.checkedCategories.push(event.id)
            }
        }
    },
    watch: {
        checkedCategories: {
            handler() {
                this.handleCategoryChecked()
            },
            deep: true
        }
    }
}
</script>

<style scoped>
</style>
